/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Rock&Run Admin API
 * OpenAPI spec version: 1.0
 */

/**
 * 배너 타입 (CONTEST, PROGRAM)
 */
export type CreateMainBannerDtoType = typeof CreateMainBannerDtoType[keyof typeof CreateMainBannerDtoType];


export const CreateMainBannerDtoType = {
  CONTEST: 'CONTEST',
  PROGRAM: 'PROGRAM',
} as const;
